const RESOURCE = {
    KEY: "ciph3rk3yhous1ngcipherk3yhous1ng",
    IV: "3ncrypth0us1ng1v",
    USER: "admin",
    PASS: "4dm1nD1sp3rk!m",
}

export default RESOURCE;